import {useCallback, useState} from 'react';

import RegionMap from './RegionMap';

const RegionMapController = props => {
    const [active, setActive] = useState(false);
    const toggle = (event, active) => {
        event.preventDefault();
        setActive(active);
    };
    const handleOpen = useCallback(event => toggle(event, true), []);
    const handleClose = useCallback(event => toggle(event, false), []);

    return (
        <RegionMap
            {...props}
            active={active}
            onOpen={handleOpen}
            onClose={handleClose}
        />
    );
};

export default RegionMapController;
